import { SVG } from '../svg';
import { IconProps } from '../types';

interface CircleCheckIconProps extends IconProps {
  variant?: 'filled' | 'outlined';
}

export function CircleCheckIcon({
  variant = 'outlined',
  ...props
}: CircleCheckIconProps): JSX.Element {
  const isFilled = variant === 'filled';

  return (
    <SVG {...props} colorTarget={isFilled ? 'fill' : 'stroke'}>
      <circle cx="12" cy="12" r="10" />
      <path d="m9 12 2 2 4-4" stroke={isFilled ? '#fff' : undefined} />
    </SVG>
  );
}
